import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-quote">
            <p className="handwritten-quote">The value is still in you.</p>
          </div>
          
          <div className="footer-links">
            <a 
              href="https://instagram.com/jamellyyyy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              Instagram
            </a>
            <Link to="/journal" className="footer-link">
              Journal
            </Link>
            <Link to="/contact" className="footer-link">
              Contact
            </Link>
          </div>
          
          <div className="footer-copyright">
            <p>&copy; 2025 JAMELLY. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 